/**
 * <Preview 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import "./Preview.scss";
import urlJoin from 'url-join';

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.handleMessageFromIframe = this.handleMessageFromIframe.bind(this);
  }

  componentWillMount() {
    window.addEventListener('message', this.handleMessageFromIframe, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessageFromIframe);
  }

  handleMessageFromIframe(e) {
    if (e.data && e.data.type) {      
      switch (e.data.type) {
        case "startEdit": {
          this.props.onStartEdit(e.data);
          break;
        }
        case "addComponent": {
          this.props.onAddComponent(e.data);
          break;
        }
        case "moveComponent": {
          this.props.onMoveComponent(e.data);
          break;
        }
        case "deleteComponent": {
          this.props.onDeleteComponent(e.data);
          break;
        }
        case "LOADED": {
          this.props.onIframeLoaded(e.data);
          break;
        }

      }  
    }
  }
  
  render() {
    const {
      isEdit,
      registerIframeRef,
      currentPagePath,
    } = this.props; 

    const schoolId = localStorage.getItem('schoolId');

    const token = localStorage.getItem('token');

    const origin = window.location.origin;

    const src = urlJoin(`${origin}:8081`, schoolId, currentPagePath);

    return (
      <div className={classnames('WebsitePreview')}>
        <iframe src={`${src}?mode=edit&t=${token}`} ref={registerIframeRef} />
      </div>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/Preview/index.js